export const UI_TEXT = {
  reveal_rate_achieved: {
    ja: "開示率: 達成",
    en: "Reveal rate: Achieved",
  },
  reveal_rate_not_achieved: {
    ja: "開示率: 未達成",
    en: "Reveal rate: Not Achieved",
  },
  item_acquisition: {
    ja: "アイテム獲得",
    en: "Item Acquisition",
  },
  final_floor_reached: {
    ja: "最終到達フロア",
    en: "Final floor reached",
  },
  possessed_items: {
    ja: "所持アイテム",
    en: "Possessed items",
  },
  reveal_rate_for_each_floor: {
    ja: "各フロアの開示率",
    en: "Reveal rate for each floor",
  },
  floor: {
    ja: "フロア",
    en: "Floor",
  },
  choose_reward: {
    ja: "フロアをクリアしました!報酬を選択してください",
    en: "Floor Cleared! Choose a reward",
  },
  none: {
    ja: "なし",
    en: "None",
  },
  no_usable_item: {
    ja: "使用できるアイテムがありません。",
    en: "No Usable Items.",
  },
  use_item: {
    ja: "アイテムを使用する",
    en: "Use Item",
  },
  use: {
    ja: "使用",
    en: "Use",
  },
  view_detail: {
    ja: (itemName: string) => itemName + "の詳細を見る",
    en: (itemName: string) => "View details of " + itemName,
  },
  close: {
    ja: "閉じる",
    en: "Close",
  },
  yes: {
    ja: "はい",
    en: "Yes",
  },
  no: {
    ja: "いいえ",
    en: "No",
  },
  play_again_with_indomitable_spirit: {
    ja:
      "不屈の心を使用し、アイテムを維持し、同じフロア番号からもう一度プレイする",
    en:
      "Use Indomitable Spirit, keep the item, and play again from the same floor number",
  },

  play_again: {
    ja: "もう一度プレイする",
    en: "Play Again",
  },
  game_over: {
    ja: "ゲームオーバー",
    en: "Game Over",
  },
  share: {
    ja: "共有",
    en: "Share",
  },
  error: {
    ja: "エラー",
    en: "Error",
  },
  this_browser_does_not_support_sharing: {
    ja: "このブラウザは共有をサポートしていません。",
    en: "This browser does not support sharing.",
  },
};
